export const RECORDER_WIN_DOWNLOADED = 'RECORDER_WIN_DOWNLOADED'
export const RECORDER_MAC_DOWNLOADED = 'RECORDER_MAC_DOWNLOADED'
export const SESSION_START = 'SESSION_START'
export const SESSION_END = 'SESSION_END'
